
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { editorUploadHandler } from "@common/src/utils/tools";
const common_base = namespace("common_base");
const common_app = namespace("common_app");
@Component({})
export default class Editor extends Vue {
  @common_base.Action getUploadToken;
  @common_app.State lang;
  editorUploadHandler = editorUploadHandler;
  get language() {
    return this.lang.replace("-", "_");
  }
}
